import React from "react";
import "./index.css";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
} from "@mui/material";

const services = [
  {
    title: "Budget-Friendly Solutions",
    description:
      "If you're curious about ratings, rankings, spotting gaps, figuring out your target audience, or getting to the bottom of customer issues, digital marketing audits are the way to go. They give you the insights you need to make smart choices and take action.",
    image: "/img/marketing/gif-1.gif",
  },
  {
    title: "Flexibility",
    description:
      "Print ads and telemarketing have made way for online marketing, where email, video, social media, and PPC ads are key players. Online marketing is booming, with more than half of customers searching for what they need. So, running an AdWords campaign with a solid keyword strategy is super important.",
    image: "/img/marketing/gif-2.gif",
  },
  {
    title: "Building Credibility",
    description:
      "Our aim is to set our business apart, gather feedback from our audience, and boost marketing effectiveness. This includes analyzing the competition, setting up KPI dashboards, and defining smart goals for customer engagement.",
    image: "/img/marketing/gif-3.gif",
  },
  {
    title: "Mixing Media",
    description:
      "Just like any strategy, online trading includes social media campaigns, creating templates, engaging in forums, blogging, content marketing, and using online directories to connect with the right crowd and build a strong online presence.",
    image: "/img/marketing/gif-4.gif",
  },
  {
    title: "Access on the Go",
    description:
      "We want to stand out and get feedback from our audience by checking how well our marketing is doing. This means looking at the competition, creating KPI dashboards, and setting smart goals for customer engagement.",
    image: "/img/marketing/gif-5.gif",
  },
  {
    title: "Smart Tracking",
    description:
      "We’re all about setting our business apart and getting audience feedback by reviewing our current marketing, analyzing the competition, setting up KPI dashboards, and defining smart goals for customer engagement.",
    image: "/img/marketing/gif-6.gif",
  },
];

const MarketingSection = () => {
  return (
    <Box
      sx={{
        // background: "#000",
        color: "white",
        padding: { xs: "40px 20px", md: "20px 40px" },
        textAlign: "center",
      }}
    >
      <Container>
        <Box
          sx={{
            padding: 5,
            border: "1px solid #DADFEF80",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "#0A2C43B2",
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ mb: 2, color: "#fff" }}
          >
            The Significance of Online Marketing
          </Typography>
          <Typography
            variant="body1"
            sx={{ maxWidth: 800, mx: "auto", mb: 4, color: "#fff" }}
          >
            Our client offerings encompass a diverse range of services tailored
            to meet the unique needs of each business. We focus on delivering
            innovative solutions that drive growth and enhance operational
            efficiency.
          </Typography>

          <div container spacing={3} className="marketing-section-outer">
            {services.map((service, index) => (
              <div className="col-md-12 col-sm-12" key={index}>
                <Card
                  sx={{
                    height: "100%",
                    width: "100%",
                    background: "linear-gradient(to bottom, #FDB4B4, #292FAB)",
                    color: "#fff",
                    boxShadow: 3,
                    borderRadius: "12px",
                    textAlign: "center",
                    border: "3px solid",
                    borderColor: "#DADFEF",
                  }}
                >
                  <CardContent>
                    <div style={{ marginBottom: 10 }}>
                      <img
                        src={service.image}
                        alt={service.title}
                        style={{
                          width: "25%",
                          height: "auto",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <Typography
                      fontWeight="bold"
                      color="#fff"
                      fontSize={"20px"}
                    >
                      {service.title}
                    </Typography>
                    <Typography sx={{ mt: 1, color: "#fff", fontSize: "16px" }}>
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default MarketingSection;
